import { ComponentBlock } from '@types';

import { types } from '@application/core/types';

import { component } from './component';
import { ImageGalleryProps } from './index';

export const block: ComponentBlock<'imageGallery', ImageGalleryProps, unknown> = {
  id: 'imageGallery',
  render: component,
  props: {
    imageGalleryData: {
      type: types.list,
    },
    imageGalleryShowBullets: {
      type: types.boolean,
    },
    imageGalleryShowFullscreenButton: {
      type: types.boolean,
    },
  },
};
